import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterOnSide extends Bloc {

	constructor (src, ctx) {

		super("filteronside", src, ctx);
		this.f = (src, ins) => [card => (ins[0] ? card.master.hand.cards.indexOf(card) === 0 : card.master.hand.cards.indexOf(card) === card.master.hand.count-1)];
		this.types = [Types.bool];
	}
}